<template>
  <v-card
    outlined
    class="d-flex flex-column blue-card py-6 px-6 align-center justify-space-between"
    :style="`min-height: ${minHeight}px`"
  >
    <div
      class="d-flex flex-column align-start f-width"
      v-if="type === 'external'"
    >
      <div class="d-flex mb-8">
        <img :src="imgSource" style="height: 52px" class="mr-4" />
        <div class="d-flex flex-column">
          <h2
            class="header__title--main mb-1"
            :class="{
              'white--text': $vuetify.theme.dark,
            }"
          >
            {{ title }}
            <sup class="newItemText" v-if="isBeta">BETA</sup>
          </h2>
          <span class="description-card--text">{{ description }}</span>
        </div>
      </div>
      <div class="d-flex flex-column justify-start f-width">
        <p
          class="d-flex align-start mb-2"
          v-for="(feature, i) in items"
          :key="`${i}--${feature.text}`"
        >
          <v-icon
            v-if="feature.check"
            small
            color="primary"
            class="mr-2"
            style="margin-top: 2px"
          >
            mdi-check-circle
          </v-icon>
          <v-icon
            v-else
            small
            color="#C2C6E7"
            class="mr-2"
            style="margin-top: 2px"
            >mdi-minus-circle</v-icon
          >
          <span v-html="feature.text" style="white-space: no-wrap"></span>
          <LearnMoreBtn
            :onClickBtn="() => handleGoToArticle(feature.article)"
            v-if="feature.article"
            customClass="ask__btn--tiny"
          />
        </p>
      </div>
    </div>
    <div class="d-flex flex-column align-start f-width" v-else>
      <div class="mb-8">
        <img :src="imgSource" style="height: 64px; margin: 0 auto" />
        <div class="d-flex flex-column text-center">
          <h2
            class="header__title--main my-2"
            :class="{
              'white--text': $vuetify.theme.dark,
            }"
            style="position: relative"
          >
            {{ title }}
            <sup class="newItemText ai" v-if="isBeta">BETA</sup>
          </h2>
          <span class="description-card--text mb-3">{{ description }}</span>
          <div v-if="isAi">
            <v-chip-legacy small class="panda-ia-chip"
              ><span class="neutral--text text--lighten-1 font-weight-medium">{{
                $i18next.t('message.ai.ai')
              }}</span></v-chip-legacy
            >
          </div>
        </div>
      </div>
      <div class="d-flex flex-column justify-start f-width">
        <p
          class="d-flex align-start mb-2"
          v-for="(feature, i) in items"
          :key="`${i}--${feature.text}`"
        >
          <v-icon
            v-if="feature.check"
            small
            color="primary"
            class="mr-2"
            style="margin-top: 2px"
          >
            mdi-check-circle
          </v-icon>
          <v-icon
            v-else
            small
            color="#C2C6E7"
            class="mr-2"
            style="margin-top: 2px"
            >mdi-minus-circle</v-icon
          >
          <span v-html="feature.text" style="white-space: no-wrap"></span>
          <LearnMoreBtn
            :onClickBtn="() => handleGoToArticle(feature.article)"
            v-if="feature.article"
            customClass="ask__btn--tiny"
          />
        </p>
      </div>
    </div>
    <div
      class="mt-4 d-flex flex-column align-center"
      :class="{
        'f-width': type === 'subtitle',
      }"
    >
      <BaseBtn
        color="primary"
        :disabled="!canDoAiOp"
        @click="emitActionBtn"
        style="width: fit-content"
        :class="{
          'f-width': type === 'subtitle',
        }"
        >{{ actionBtnText }}</BaseBtn
      >
      <p class="end-description mb-0 mt-1 text-center" v-if="bottomText">
        {{ bottomText }}
      </p>
    </div>
  </v-card>
</template>

<script>
import BaseBtn from '@/components/BaseBtn'
import LearnMoreBtn from '@/components/LearnMoreBtn.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateVideoOptionCard',
  computed: {
    ...mapGetters('user', ['canSeePlanInfo']),
    canDoAiOp() {
      if (this.isAi && !this.canSeePlanInfo) return false
      return true
    },
  },
  components: {
    BaseBtn,
    LearnMoreBtn,
  },
  props: {
    isAi: {
      type: Boolean,
      default: false,
    },
    imgSource: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: false,
    },
    actionBtnText: {
      type: String,
      required: true,
    },
    bottomText: {
      type: String,
      required: false,
      default: '',
    },
    isBeta: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      default: 'external',
    },
    minHeight: {
      type: Number,
      default: 425,
    },
  },
  methods: {
    emitActionBtn() {
      this.$emit('action')
    },
    handleGoToArticle(article) {
      const articleLink =
        article[this.$i18next.resolvedLanguage] ?? article['en']
      window.open(articleLink, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/header';

.blue-card {
  background: #f8f8ff;
  border: 1px solid #a0acff;
  border-radius: 4px;
  height: 100%;
}

.end-description {
  color: var(--v-neutral-lighten1);
  font-size: 14px;
}

.description-card--text {
  color: var(--v-blueMarine-darken2);
  font-size: 16px;
}

.panda-ia-chip {
  background: var(--v-brand-lighten2) !important;
}
</style>
